import { makeStyles } from '@mui/styles';

const globalUseStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
  },
  infoColor: {
    color: theme?.palette?.info?.main,
  },
  warningColor: {
    color: `${theme?.palette?.warning?.main} !important`,
  },
  marginTopZero: {
    marginTop: '0px !important',
  },
  error: {
    color: `${theme?.palette?.error?.main} !important`,
  },
  infoBg: {
    background: '#f3fbff',
  },
  flex: {
    display: 'flex',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center',
  },
  flexColumnStart: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'base-line',
  },
  flexRowEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  flexRowStart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  flexRowJustifySpaceBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexRowJustifySpaceAround: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  flexRowAlignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  flexJustifyCenter: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  approvedBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.approved}`,
  },
  pendingBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.pending}`,
  },
  rejectedBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.rejected}`,
  },
  withdrawnBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.withdrawn}`,
  },
  RecalledBorder: {
    borderLeft: `4px solid #009fd4`,
  },
  updateBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.update}`,
  },
  newBorder: {
    borderLeft: `4px solid ${theme?.statuscolors?.New}`,
  },
  approved: {
    background: theme?.statuscolors?.approved,
  },
  pending: {
    background: theme?.statuscolors?.pending,
  },
  rejected: {
    background: theme?.statuscolors?.rejected,
  },
  withdrawn: {
    background: theme?.statuscolors?.withdrawn,
  },
  Recalled: {
    background: '#009fd4',
  },
  update: {
    background: theme?.statuscolors?.update,
  },
  New: {
    background: theme?.statuscolors?.New,
  },
  statusColorDot: {
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '3px',
  },
  textOverFlow: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'block',
    textOverflow: 'ellipsis',
  },
  displayNone: {
    display: 'none !important',
  },
  displayBlock: {
    display: 'block',
  },
  displayInlineblock: {
    display: 'inline-block',
  },
  visibilityHidden: {
    visibility: 'hidden',
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  textAlignCenter: {
    textAlign: 'center !important',
  },
  textDecorationNone: {
    textDecoration: 'none',
  },
  statusStyling: {
    boxShadow: theme?.palette?.customBoxShadows?.boxShadow,
    padding: `${theme.spacing(1.5)}px ${theme.spacing(1.5)}px`,
    borderRadius: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      backgroundColor: theme?.palette?.background?.paper,
    },
  },
  wordBreakAll: {
    wordBreak: 'break-all',
  },
  wordBreak_BreakWord: {
    wordBreak: 'break-word',
  },
  lightColor: {
    color: '#1A1A1A',
    wordBreak: 'break-word',
  },
  styledText: {
    fontSize: '12px',
    color: '#546e7a !important',
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',
  },
  downloadFile: {
    fontSize: '12px',
    display: 'flex',
    wordBreak: 'break-all',
  },
  downloadIcon: {
    fontSize: '1.2em',
  },
  outlineNone: {
    '&:focus': {
      outline: 'none !important',
    },
  },
  positionRelative: {
    position: 'relative !important',
  },
  mainIconColor: {
    color: theme.palette.primary.main,
  },
  profilePic: {
    // color: `${theme.palette.info.main} !important`,
    color: `#F400FF !important`,
    backgroundColor: '#F8E1F9 !important',
    // border: `1px solid ${theme.palette.info.main}`,
    width: `${theme.spacing(3.5)} !important`,
    height: `${theme.spacing(3.5)} !important`,
    fontSize: '15px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderRadius: '50px',
  },
  smallProfilePic: {
    color: theme.palette.background.paper,
    // backgroundColor: `${theme?.palette?.primary?.main} !important`,
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    fontSize: '18px',
    border: `3px solid ${theme?.palette?.grey[200]}`,
  },
  attributes: {
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme?.palette?.grey[400]} !important`,
  },
  copyText: {
    cursor: 'pointer',
    '&&:hover': {
      color: '#354ed6',
      fontWeight: 600,
    },
  },
  dataGridColumWrap: {
    whiteSpace: 'break-spaces',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0px',
  },
  loaderContainer: {
    height: '30vh',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
}));

export default globalUseStyles;
